export const MAX_DETAIL_CHARACTERS = 400;
